export const signin = {
  LastUsed: "Last used",
  SignInToYourAccount: "Sign in to your Fullscript account",
  DoYouNormallySignInWithGoogle: "Do you normally sign in with Google?",
  LearnHowToSignInWithoutGoogle: "Learn how to sign in without Google.",
  PasswordIsRequired: "Password is required",
  IncorrectEmailOrPassword: "Incorrect email or password. Please try again.",
  Continue: "Continue",
  EmailRequired: "Email is required",
  EmailMustHaveAt: `Email must include "@"`,
  Email: "Email",
  HowToSignInWithoutGoogle: "How to sign into Fullscript without Google",
  SuccessfullyConnected: "You have successfully connected!",
  YoureNowReady: "You are now ready to start using Fullscript directly in {{ displayName }}.",
  ConnectToPatients: "Connect your {{ patientTerm }}.",
  CreateTreatmentPlan: "Create a supplement {{ treatmentPlanTerm }}.",
  WatchYourPatients: "Watch your {{ patientTerm }} get better — and your practice grow.",
  CloseWindowAndStartAgain: "Close this window and start again.",
  CloseWindow: "Close this window.",
  GetStarted: "Get started",
  YourPracticeNeedsAC: "Your practice needs to sign an A&C",
  NeedsSignedAC:
    "In order to begin building supplement plans, your practice needs to complete an Authorization & Consent agreement with Fullscript. Contact <0>{{supportEmail}}</0> to get an A&C in place and gain full access to the integration.",
  YourPracticeNeedsBAA: "Your practice needs a BAA.",
  NeedsSignedBAA:
    "In order to begin building supplement plans, your practice needs to complete a BAA (Business Associate Agreement) with Fullscript. Contact <0>{{supportEmail}}</0> to get a BAA in place and gain full access to the integration.",
  PracticeIdClaimed: "Your Fullscript Store is linked to a different practice.",
  AccountAlreadyLinked: "Your Fullscript user is linked to a different {{displayName}} provider.",
  AssociatedWithADifferentFsStore:
    "Each Fullscript Store can only be linked to a single {{displayName}} practice.  Talk to your Fullscript Store Owner, or contact  <0>{{supportEmail}}</0> for help.",
  LinkedToDifferentProvider:
    "Each Fullscript user account can only be linked to a single {{displayName}} provider account. Try logging in with a different user, or un-link your account from {{displayName}} in Account Settings in the  <0>{{webApp}}</0>",
  GoBackToSignIn: "Go back to sign in",
  SomethingWentWrong: "Something went wrong...",
  GoogleIsNotSupported: `"Sign In with Google" is not supported from within {{displayName}} yet. If you normally sign
      in using Google, you can add a password to your Fullscript account in order to be able to
      sign in through {{displayName}}.`,
  AddFullscriptPassword: "Add a Fullscript password",
  LogInWithGoogle: "Log into the Fullscript main web app using Sign In with Google",
  ClickOnUserIcon: "Click on your user avatar menu in the top right corner",
  ClickOnUserIconSidebar: "Click on your name in the bottom left sidebar",
  ChooseAccountSettings: 'Choose "Account Settings"',
  ScrollToLogin: 'Select "Security" and add a password',
  UseThisPassword: "Use this password to log into Fullscript from {{displayName}}.",
  ReviewBAA: "Review and sign the terms of service for this Fullscript integration",
  ResendActivationLink: "If you haven't activated your account yet, please activate it here:",
  TermsOfServiceCheckboxLabel:
    "I agree to Fullscript's <tos>Terms of Service</tos> and <privacy>Privacy Statement</privacy>",
  seamlessSignIn: {
    channel: {
      title: "Confirm it’s you",
      subtitle:
        "We’ll send a one-time passcode to your email or phone number. This helps keep your information private and secure.",
      email: "Email me",
      sms: "Text me",
      sendPasscode: "Send passcode",
      or: "or",
      signInWithPassword: "Sign in with password",
      resend: "Resend passcode",
      resendIn: "You can resend in {{seconds}}s",
      codeSentEmail: "Code sent by email to {{destination}}.",
      codeSentSms: "Code sent by text to {{destination}}.",
      codeSentEmailFallback: "Code sent by email.",
      codeSentSmsFallback: "Code sent by text.",
    },
    otpInput: {
      groupLabel: "One-time passcode",
      digitLabel: "Digit {{index}} of {{total}}",
      attemptsRemaining: "{{count}} of {{max}} attempt remaining",
      attemptsRemaining_plural: "{{count}} of {{max}} attempts remaining",
    },
    gate: {
      heading: "Confirm it’s you",
      subcopy: "Passcode sent to <strong>{{destination}}</strong>.",
      codeExpiresIn10Minutes: "Expires in 10 minutes.",
      switchToEmail: "Email me instead",
      switchToPhone: "Text me instead",
      submitting: "Verifying your code",
      resendCode: "Resend code",
      resendCodeCountdown: "Resend code ({{seconds}}s)",
    },
    errors: {
      invalidCode: "That code didn’t match. Try again, or resend a new code.",
      codeExpired: "That code expired. Resend a new code to continue.",
      lockedOut: "Too many attempts. Please try again later.",
      noActiveChallenge: "Request a new code to continue.",
      resendRateLimited: "You’re requesting codes too quickly. Wait a moment, then try again.",
      sendFailed: "We couldn’t send your code. Try again, or choose another option.",
    },
  },
};
